
import { Template, LazyTemplate } from "../../../core/template/index";
import { View } from "../../../core/view";

export default class TestStep02View extends View
{
    public template = Template.lazy('/views/testChain/step02/index.html');
}